import styled from 'styled-components';

export const CollapseWrapper = styled.div`
    .ant-collapse {
        margin-top: 24px;
    }
`;
